<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="site_settings"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class SitesettingsShow extends Vue {
  data = {}

  columns = [
    {
      prop: 'order_notification_emails',
      label: '订单情况通知邮箱',
    },
    {
      prop: 'wechat_settlement_emails',
      label: '微信提现通知邮箱',
    },
    {
      prop: 'express_base_fee',
      label: '邮费',
    },
    {
      prop: 'order_amount_in_express_free',
      label: '免邮订单金额',
    },
    {
      prop: 'refund_name',
      label: '退货收货人名字',
    },
    {
      prop: 'refund_phone',
      label: '退货联系电话',
    },
    {
      prop: 'refund_address',
      label: '退货地址',
    },
    {
      prop: 'custom_service_wechat_account',
      label: '客服微信号'
    },
    {
      prop: 'custom_service_cover',
      label: '客服微信图片',
      renderCell: {
        type: 'image',
        width: '100px',
        height: 'auto'
      }
    },
    {
      prop: 'personal_page_background_cover',
      label: '个人中心页背景图',
      renderCell: {
        type: 'image',
        width: '150px',
        height: 'auto'
      }
    },
    {
      prop: 'home_page_share_word',
      label: '首页分享卡片分享语'
    },
    {
      prop: 'human_home_page_share_covers',
      label: '首页分享卡片图',
      renderCell(h, { row }) {
        const imgs = row.human_home_page_share_covers;
        return _.map(imgs, ({ src, click_count }) => {
           return (
             <div>
               <el-image src={src} fit="cover" style={{ width: '100px', height: 'auto' }} preview-src-list={imgs}></el-image>
               <span style="margin-left: 10px;">点击次数：{ click_count }</span>
            </div>
           )
        })
      }
    },
    {
      prop: 'home_page_share_background_covers',
      label: '首页分享海报图',
      renderCell: {
        type: 'image',
        width: '100px',
        height: 'auto'
      }
    },
    {
      prop: 'home_page_popup_cover',
      label: '首页弹窗',
      renderCell: {
        type: 'image',
        width: '100px',
        height: 'auto'
      }
    },
    {
      prop: 'action',
      label: '操作',
      edit: true
    }
  ];

  async mounted() {
    this.data = await this.$request.get('/site_settings');
  }
}
</script>
